import { Children, isValidElement } from 'react';

const getChildKey = (child) => child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    Children.forEach(children, (child) => {
        if (isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}

export { getChildKey, onlyElements };
//# sourceMappingURL=utils.mjs.map
